import { render, staticRenderFns } from "./ProblemCard.vue?vue&type=template&id=30f00e15&scoped=true&"
import script from "./ProblemCard.vue?vue&type=script&lang=js&"
export * from "./ProblemCard.vue?vue&type=script&lang=js&"
import style0 from "./ProblemCard.vue?vue&type=style&index=0&id=30f00e15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f00e15",
  null
  
)

export default component.exports